var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { Alert, Checkmark } from '@volkswagen-onehub/icons-core';
import { styled, ThemeProvider } from '../theme-provider';
import { getCommonProps } from '../helpers/common-props';
import { getNotificationColor } from '../helpers/input';
import { Container, ContainerGutter, ContainerPadding } from '../container';
import { Text } from '../text';
const getIcon = (appearance) => {
    switch (appearance) {
        case 'success':
            return Checkmark;
        case 'error':
        case 'default':
        default:
            return Alert;
    }
};
const StyledInfobox = styled.div.withConfig({ displayName: "StyledInfobox", componentId: "sc-16u4l1c" }) `display:inline-block;width:${(props) => props.fullWidth && '100%'};border-radius:4px;background-color:${getNotificationColor};`;
// Actual Icon will be replaced depending on Appearance
const StyledIcon = styled(Alert).withConfig({ displayName: "StyledIcon", componentId: "sc-145nlbo" }) `display:block;color:${(props) => props.theme.colors.content.primary};`;
export const Infobox = (props) => {
    const { ariaLabel, ariaLive, children, fullWidth, hideIcon, appearance, role = 'alert' } = props, rest = __rest(props, ["ariaLabel", "ariaLive", "children", "fullWidth", "hideIcon", "appearance", "role"]);
    const commonProps = getCommonProps(props);
    return (React.createElement(ThemeProvider, { theme: "main" },
        React.createElement(StyledInfobox, Object.assign({ role: role, "aria-label": ariaLabel, "aria-live": ariaLive, "aria-atomic": true, fullWidth: fullWidth, appearance: appearance }, commonProps, rest),
            React.createElement(ThemeProvider, { theme: "inverted" },
                React.createElement(Container, { gutter: ContainerGutter.static200, wrap: "never", padding: ContainerPadding.static200, shrinkContent: true },
                    !hideIcon && (React.createElement(StyledIcon, { variant: "default", ariaHidden: true, as: getIcon(appearance) })),
                    typeof children === 'string' ? React.createElement(Text, null, children) : children)))));
};
